export default "__VITE_ASSET__DWbDFxX0__"